import React, { useEffect, useState, useRef } from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import OverlayedLayout from "./Layouts/Overlayed";
import TwoColumnLayout from "./Layouts/TwoColumn";
import TwoColumnGridLayout from "./Layouts/TwoColumnGrid";
import "./TextWithMedia.scss";

const layouts = {
  "overlayed": OverlayedLayout,
  "2column": TwoColumnLayout,
  "twocolumn-grid": TwoColumnGridLayout,
};

export const TextWithMedia = ({settings, blocks, props}) =>
{
    const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
    let Layout = layouts[settings.layout_type] || TwoColumnLayout;
    const contentRef: any = useRef(null); // Ref to measure the content height

    if (isMobile) {
        Layout = layouts[settings.layout_type_mobile] || TwoColumnLayout;
    }

    if (settings.render_type !== "all") {
        if (isMobile && settings.render_type !== "mobile-only") return null;
        if (!isMobile && settings.render_type !== "desktop-only") return null;
    }

    return (
      <div
          className={`${settings.reveal_animation_class} relative`}
          style={{
            paddingTop: `${isMobile ? settings.padding_top_mobile : settings.padding_top_desktop}px`,
            paddingBottom: `${isMobile ? settings.padding_bottom_mobile : settings.padding_bottom_desktop}px`,
            minHeight: `${isMobile ? settings.mobile_min_height : settings.desktop_min_height}px`,
          }}>

      <div
            ref={contentRef}
            className={`relative w-full h-full justify-end items-end`}
        >
            <Layout
              blocks={blocks}
              settings={settings}
              props={props}
          />
        </div>
      </div>
  );
};
